export type ASINType = string;
export type ObfuscatedMerchantIdType = string;
export type URLType = string
export type CurrencySymbol = string;
export type VisitType = string;
export type OffsetTimeType = string;
// State code, e.g. WA, CA, TX etc.
export type StateCode = string;
// i.e. State. To avoid naming confusing with React State, name it StateEntity.
export interface StateEntity {
    readonly label: string,
    readonly stateCode: StateCode,
    /**
     * @deprecated sync project will support all states + DC, so this attribute no longer needed.
     */
    readonly launched: boolean
}

export interface PriceType {
    readonly amount: number;
    readonly currencySymbol: CurrencySymbol
}

export interface LinkType {
    readonly url: string;
    readonly text: string;
}

/**
 * This enum defines some common error code that UI may understand to show error message.
 */
export enum API_ERROR_CODE {
    /**
     * A general error represent a error happen for ajax call (e.g. 500/404),
     * In most case, customer don't care about 500/404/400, so showing a unique error message in general is sufficient from UX perspective.
     */
    GENERAL_ERROR
}

/**
 * Enum to define the current page type that buybox is hosted in.
 */
export enum BUY_BOX_PAGE_TYPE {
    DETAIL_PAGE = "DETAIL_PAGE",
    OFFER_BUYBOX_PAGE = "OFFER_BUYBOX_PAGE"
}